module.exports = __webpack_public_path__ + "static/media/card-template.4aff793f.svg";